import { GET } from "./_config";

export const getNewsLetterListApi = async (query: string) =>
  await GET(`/super-admin/news-letters?${query || ""}`, true);
